<template lang="pug">
  div(class="container-xl px-0 gallery-2 py-3")
    swiper(:options="swiperOptions" ref="mySwiper" class="mt-2")
      swiper-slide(v-for="image in $parent.gallery")
        div.w-100
          img(:src="image" :key="image" class="img-fluid swiper-lazy")
        //- .swiper-lazy-preloader.swiper-lazy-preloader-white
      .swiper-button-prev(slot="button-prev")
      .swiper-button-next(slot="button-next")

</template>

<script>
import { swiper, swiperSlide } from 'vue-awesome-swiper'

export default {
  components: {
    swiper,
    swiperSlide
  },
  data: () => ({
    swiperOptions: {
      autoHeight: true,
      // lazy: true,
      loop: true,
      autoplay: false,
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
        clickable: true,
      },

    }
  })
}
</script>

<style scoped>
.gallery-2 .swiper-slide {
  text-align: center;
}

.gallery-2 img {
  max-height: 600px;
  margin: auto;
}
</style>